module.exports = __webpack_public_path__ + "assets/icons/ic_qr_24px.svg";